import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { RippleButton } from '@isyc-react/form/modules/base/button';
import { ViewerArchiveContainer, ViewerControlsContainer } from "../viewer/container";
import { ViewArchiveInfo } from "../viewer/status";
import { ViewArchiveTxt } from "../viewer/archive/text";
import { Spinner } from '@isyc-react/design/bootstrap';
import { useArchiveDownload } from "../hooks";
import { ViewerControlButton, ViewerControlButtonDownload, ViewerControlsBox, ViewerControlTooltip } from "../viewer/controls";
import { useTranslation } from 'react-i18next';
import { nsarchives } from "../../i18n/namespaces";
const ViewerControlButtonViewText = props => {
  const {
    disabled,
    onClick
  } = props;
  const {
    t
  } = useTranslation(nsarchives.common);
  return /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.seeAsText')
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    disabled: disabled,
    onClick: () => onClick && onClick()
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-eye"
  })));
};

// TODO allow selection to choose opening in some other formats rather than plain text
// TODO allow opening at first checking the file extension (example mimetype 'application/octet-stream' and extension '.dng'
// should suggest opening as tiff, etc.)
export const ViewArchiveFallback = props => {
  const {
    archive,
    mime,
    name
  } = props;
  const [download, {
    loading,
    error
  }] = useArchiveDownload(archive, name, mime);
  const [view, setView] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, view ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewArchiveTxt, {
    archive: archive,
    name: name
  })) : /*#__PURE__*/React.createElement(ViewerArchiveContainer, null, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-fallback d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlButtonViewText, {
    onClick: () => setView(true)
  }), /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: archive,
    name: name
  }))), /*#__PURE__*/React.createElement(ViewArchiveInfo, {
    className: "flex-column"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "me-3"
  }, "Aper\xE7u non disponible pour ce format de fichier"), /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-primary rounded-xxl",
    onClick: () => download()
  }, loading ? /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    size: "sm"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-download"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ms-2"
  }, "T\xE9l\xE9charger"))), /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "me-3"
  }, "ou ouvrez la vue du fichier en texte brut"), /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-outline-primary rounded-xxl",
    onClick: () => setView(true)
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-eye"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ms-2"
  }, "Voir"))), error && /*#__PURE__*/React.createElement("div", {
    className: "mt-2 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-alert text-danger font-size-22"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-danger ms-2"
  }, "Error downloading file ", name)))));
};